import ButtonWithLoader from "../../../../../../common/components/ui/loading/ButtonLoading";
import { useToastContext } from '../../../../../../common/components/ui/toast/toast.context';
import { useMemo, useState } from "react";
import { ContractProps } from "../../../../services/integration.api";
import { FaCheckCircle } from "react-icons/fa";
import { ApiResponseType } from "../../../../../../common/helpers/api.helpers";

type FormPropsCreateRenter = {
  onSave: (vehicleId: string) => void
  contractData: ContractProps
  disabled?: boolean
  handleSignature: (contractInfo: object) => void
  contractFn: (data: ContractProps) => Promise<ApiResponseType<unknown>>
};

export default function ZapSignActivate(props: FormPropsCreateRenter) {
  const { notifySuccess, notifyError } = useToastContext()
  const [bindContractInProgress, setBindContractInProgress] = useState(false)
  const [buttonColor, setButtonColor] = useState<string>('text-redPrimary');

  async function handleCreateContract() {
    try {
      setBindContractInProgress(true)
      const contractProps = props.contractData;
      const result = await props.contractFn(contractProps)
      if (!result.ok) {
        notifyError("Erro ao gerar link do contrato!")
        return
      }

      props.handleSignature(result)

      notifySuccess("Link do contrato gerado com sucesso!")
      setButtonColor('success')
    } catch (err) {
      console.log(err)
    } finally {
      setBindContractInProgress(false)
    }
  }
  const badgeColor = useMemo(() =>
    (buttonColor == "success")
      ? 'text-greenPrimary'
      : 'text-gray'
    , [buttonColor])

  return (
    <div className="grid-class">
      <div>
        <h2 className="font-semibold ">Clique aqui para gerar o contrato:</h2>
      </div>
      <div className="grid-div2">
        <ButtonWithLoader
          type="button"
          disabled={props.disabled || bindContractInProgress}
          isLoading={bindContractInProgress} onClick={handleCreateContract}>
          Contrato
        </ButtonWithLoader>
        <FaCheckCircle size={24} className={`${badgeColor}`} />
      </div>
    </div>

  )
}
